import {
  FACEBOOK,
  INSTAGRAM,
  LINKEDIN_BUSINESS_PAGE,
  YOUTUBE,
  GOOGLE,
  TIKTOK_BUSINESS_PAGE, WHATSAPP
} from '../constants';
import { PLATFORM_COLORS, PLATFORM_ICONS } from '../icons';

export const COMMUNICATION_SUPPORTED_PLATFORMS = [
  {
    platform: FACEBOOK,
    icon: PLATFORM_ICONS[FACEBOOK],
    color: PLATFORM_COLORS[FACEBOOK]
  },
  {
    platform: INSTAGRAM,
    icon: PLATFORM_ICONS[INSTAGRAM],
    color: PLATFORM_COLORS[INSTAGRAM]
  },
  {
    platform: LINKEDIN_BUSINESS_PAGE,
    icon: PLATFORM_ICONS[LINKEDIN_BUSINESS_PAGE],
    color: PLATFORM_COLORS[LINKEDIN_BUSINESS_PAGE]
  },
  {
    platform: YOUTUBE,
    icon: PLATFORM_ICONS[YOUTUBE],
    color: PLATFORM_COLORS[YOUTUBE]
  },
  {
    platform: GOOGLE,
    icon: PLATFORM_ICONS[GOOGLE],
    color: PLATFORM_COLORS[GOOGLE]
  },
  {
    platform: TIKTOK_BUSINESS_PAGE,
    icon: PLATFORM_ICONS[TIKTOK_BUSINESS_PAGE],
    color: PLATFORM_COLORS[TIKTOK_BUSINESS_PAGE]
  },
  {
    platform: WHATSAPP,
    icon: PLATFORM_ICONS[WHATSAPP],
    color: PLATFORM_COLORS[WHATSAPP]
  }
];
